import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Handbag, List, X, User } from "@phosphor-icons/react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

const Header = () => {
  const { count, setOpen } = useCart();
  const { user } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  const [menu, setMenu] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { to: "/shop", label: "Collection" },
    { to: "/#manifesto", label: "Manifesto" },
    { to: "/#atelier", label: "Atelier" },
  ];

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled || pathname !== "/" ? "bg-[#0A0A0C]/85 backdrop-blur-xl border-b border-line" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 h-[72px] flex items-center justify-between">
        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="overline link-underline text-bone/80 hover:text-bone"
            >
              {l.label}
            </Link>
          ))}
        </div>

        <button className="md:hidden text-bone" onClick={() => setMenu(true)} data-testid="mobile-menu-open">
          <List size={24} weight="thin" />
        </button>

        <Link
          to="/"
          data-testid="logo-home"
          className="font-serif text-2xl md:text-3xl tracking-[0.12em] text-bone absolute left-1/2 -translate-x-1/2"
        >
          TAMASHii
        </Link>

        <div className="flex items-center gap-5">
          <Link
            to={user ? "/account" : "/account/login"}
            data-testid="account-link"
            className="flex items-center gap-2 text-bone group"
          >
            <span className="overline hidden md:inline group-hover:text-crimson transition-colors">{user ? "Account" : "Sign In"}</span>
            <User size={22} weight="thin" />
          </Link>
          <button
            onClick={() => setOpen(true)}
            data-testid="cart-button"
            className="relative flex items-center gap-2 text-bone group"
          >
            <span className="overline hidden md:inline group-hover:text-crimson transition-colors">Cart</span>
            <Handbag size={22} weight="thin" />
            {count > 0 && (
              <span
                data-testid="cart-count"
                className="absolute -top-2 -right-3 bg-crimson text-bone font-mono text-[10px] w-4 h-4 flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </button>
        </div>
      </div>

      {menu && (
        <div className="fixed inset-0 bg-[#0A0A0C] z-50 flex flex-col p-6 md:hidden">
          <div className="flex justify-end">
            <button onClick={() => setMenu(false)} className="text-bone" data-testid="mobile-menu-close">
              <X size={26} weight="thin" />
            </button>
          </div>
          <nav className="flex flex-col gap-6 mt-16">
            {links.map((l) => (
              <Link
                key={l.label}
                to={l.to}
                onClick={() => setMenu(false)}
                className="font-serif text-4xl text-bone"
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
